var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoletins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2431 17H1.98385C1.72274 16.9995 1.4725 16.8954 1.28805 16.7106C1.10359 16.5258 1 16.2754 1 16.0142V3.46346C1 3.20253 1.10366 2.95228 1.28816 2.76778C1.47267 2.58327 1.72292 2.47961 1.98385 2.47961H17.2431C17.504 2.47961 17.7543 2.58327 17.9388 2.76778C18.1233 2.95228 18.2269 3.20253 18.2269 3.46346V16.0142C18.2269 16.2754 18.1233 16.5258 17.9389 16.7106C17.7544 16.8954 17.5042 16.9995 17.2431 17V17Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2269 9.8623V16.0142C18.2269 16.2753 18.1233 16.5258 17.9389 16.7106C17.7544 16.8954 17.5042 16.9995 17.2431 17H10.3523C10.3523 17 14.2896 15.7692 18.2269 9.8623Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2269 6.90885H1V3.46346C1 3.20253 1.10366 2.95228 1.28816 2.76778C1.47267 2.58327 1.72292 2.47961 1.98385 2.47961H17.2431C17.504 2.47961 17.7543 2.58327 17.9388 2.76778C18.1233 2.95228 18.2269 3.20253 18.2269 3.46346V6.90885Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69225 3.95538C4.39983 3.95576 4.11387 3.86936 3.87057 3.70714C3.62727 3.54491 3.43758 3.31415 3.3255 3.04406C3.21342 2.77397 3.18399 2.4767 3.24095 2.18988C3.2979 1.90305 3.43868 1.63958 3.64545 1.43281C3.85223 1.22603 4.1157 1.08526 4.40252 1.0283C4.68934 0.971345 4.98662 1.00077 5.25671 1.11285C5.5268 1.22493 5.75756 1.41462 5.91979 1.65792C6.08201 1.90122 6.1684 2.18718 6.16802 2.4796",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86034 3.95538C9.56792 3.95576 9.28196 3.86936 9.03866 3.70714C8.79536 3.54491 8.60567 3.31415 8.49359 3.04406C8.38151 2.77397 8.35208 2.4767 8.40904 2.18988C8.46599 1.90305 8.60677 1.63958 8.81354 1.43281C9.02032 1.22603 9.28379 1.08526 9.57061 1.0283C9.85743 0.971345 10.1547 1.00077 10.4248 1.11285C10.6949 1.22493 10.9257 1.41462 11.0879 1.65792C11.2501 1.90122 11.3365 2.18718 11.3361 2.4796",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0284 3.95538C14.736 3.95576 14.45 3.86936 14.2068 3.70714C13.9635 3.54491 13.7738 3.31415 13.6617 3.04406C13.5496 2.77397 13.5202 2.4767 13.5771 2.18988C13.6341 1.90305 13.7749 1.63958 13.9816 1.43281C14.1884 1.22603 14.4519 1.08526 14.7387 1.0283C15.0255 0.971345 15.3228 1.00077 15.5929 1.11285C15.863 1.22493 16.0937 1.41462 16.256 1.65792C16.4182 1.90122 16.5046 2.18718 16.5042 2.4796",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.37036H18.2269",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.8319H11.296",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.2915H11.296",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44543 6.90881V17",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89075 6.90881V17",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3362 6.90881V10.2489",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7815 6.90881V10.6987",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44539 9.37036H1V11.8319H4.44539V9.37036Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89082 14.2915H4.44543V16.998H7.89082V14.2915Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3361 6.90881H7.89075V9.37035H11.3361V6.90881Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2269 9.8623C14.2896 15.7692 10.3523 17 10.3523 17C10.3523 17 12.1917 14.2322 10.9744 10.4825C10.962 10.4477 10.9594 10.4101 10.9667 10.3739C10.9741 10.3377 10.9912 10.3043 11.0162 10.2771C11.0413 10.2499 11.0732 10.23 11.1087 10.2197C11.1441 10.2093 11.1818 10.2089 11.2175 10.2183C12.3544 10.5322 15.7845 11.2979 18.2269 9.8623Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15198 5.43311H12.0751",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7815 5.43311H16.7511",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44544 5.43311H2.47583",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoletins);
export default __webpack_public_path__ + "static/media/boletins.3b08bea9be1283f6b358f57bee52b209.svg";
export { ForwardRef as ReactComponent };